import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback, useState } from 'react';
import { changeSelfAvatarPartColor } from '../../../redux/actions/selfAvatarActions';
import { useAppDispatch } from '../../../redux/store';
import { ColorPickerModal } from './colorPickerModal';
export const AvatarColorControl = ({ colorTypeDefinition, currentColor, otherColorLuminosity }) => {
    const dispatch = useAppDispatch();
    const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
    const onColorClicked = useCallback((color) => {
        dispatch(changeSelfAvatarPartColor(colorTypeDefinition.colorType, color));
    }, [dispatch, colorTypeDefinition.colorType]);
    const openColorPicker = useCallback(() => {
        setIsColorPickerOpen(true);
    }, []);
    const closeColorPicker = useCallback(() => {
        setIsColorPickerOpen(false);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(Button, { variant: 'outlined', onClick: openColorPicker, children: [colorTypeDefinition.label, ' ', _jsx("div", { css: css `
            min-width: 30px;
            min-height: 30px;
            width: 30px;
            height: 30px;
            background-color: ${currentColor};
            border: 2px solid black;
            margin-left: 5px;
          ` })] }), isColorPickerOpen && (_jsx(ColorPickerModal, { title: colorTypeDefinition.label, onColorClicked: onColorClicked, onClose: closeColorPicker, otherColorLuminosity: otherColorLuminosity }))] }));
};
